module.exports = __webpack_public_path__ + "img/scene_party_big@2x.0aef9a61.png";